export default __webpack_public_path__ + "static/media/twoCol.6ff01351.svg";